import { firebaseOptions, restaurantShim } from "@/config"
import { App, ConceptKey, RestaurantShimKey, fetchConcept, firebase } from "@mmh/web-core"
import { analytics } from "@mmh/web-core/plugins/analytics"
import { storage } from "@mmh/web-core/plugins/storage"
import { PiniaColada as colada } from "@pinia/colada"
import { createPinia } from "pinia"
import { ViteSSG } from "vite-ssg"
import "./assets/index.css"
import { routerOptions } from "./plugins/router"

if (import.meta.env.SSR && typeof window !== "undefined") {
    window.scrollTo = () => {}
}

let ssrConceptCache: Awaited<ReturnType<typeof fetchConcept>> | null = null

export const createApp = ViteSSG(
    App,
    routerOptions,
    async ({ app, initialState }) => {
        let concept
        
        if (import.meta.env.SSR) {
            if (!ssrConceptCache) {
                ssrConceptCache = await fetchConcept("ospi")
            }
            concept = ssrConceptCache
            initialState.concept = concept
        } else {
            concept = initialState.concept || await fetchConcept("ospi")
        }
        
        const pinia = createPinia()
        app.use(pinia)
        app.use(colada, {})
        
        if (!import.meta.env.SSR) {
            try {
                app.use(firebase, firebaseOptions)
                app.use(analytics)
                app.use(storage)
            } catch (error) {
                console.warn("Firebase initialization failed:", error)
            }
        }
        
        app.provide(ConceptKey, concept)
        app.provide(RestaurantShimKey, restaurantShim)
    }
)
